import React, { useState } from "react"
import { postavy, type Postava } from "./postavy-data"
import cookieBg from "./cookie-bg.png"
import bgMenu from "./bg-menu.png"

const COOKIES_LARGE = [
  { left: "6%", size: 88, dur: 16, delay: -3 },
  { left: "18%", size: 72, dur: 13, delay: -7 },
  { left: "31%", size: 80, dur: 15, delay: -10 },
  { left: "44%", size: 68, dur: 12, delay: -2 },
  { left: "57%", size: 84, dur: 17, delay: -5 },
  { left: "70%", size: 76, dur: 14, delay: -9 },
  { left: "83%", size: 90, dur: 16, delay: -4 },
  { left: "95%", size: 70, dur: 13, delay: -8 },
  { left: "12%", size: 64, dur: 14, delay: -11 },
  { left: "24%", size: 96, dur: 18, delay: -6 },
  { left: "35%", size: 74, dur: 12, delay: -1 },
  { left: "48%", size: 86, dur: 15, delay: -12 },
  { left: "61%", size: 66, dur: 13, delay: -3 },
  { left: "74%", size: 92, dur: 17, delay: -10 },
  { left: "87%", size: 78, dur: 14, delay: -5 },
  { left: "98%", size: 62, dur: 12, delay: -9 },
]
const COOKIES_SMALL = [
  { left: "10%", size: 36, dur: 11, delay: -6 },
  { left: "24%", size: 32, dur: 9, delay: -1 },
  { left: "37%", size: 40, dur: 12, delay: -4 },
  { left: "51%", size: 34, dur: 10, delay: -7 },
  { left: "65%", size: 38, dur: 11, delay: -2 },
  { left: "79%", size: 32, dur: 10, delay: -9 },
  { left: "92%", size: 36, dur: 12, delay: -5 },
  { left: "7%", size: 30, dur: 9, delay: -11 },
  { left: "16%", size: 42, dur: 12, delay: -8 },
  { left: "29%", size: 28, dur: 10, delay: -3 },
  { left: "43%", size: 44, dur: 11, delay: -10 },
  { left: "56%", size: 31, dur: 9, delay: -4 },
  { left: "69%", size: 46, dur: 12, delay: -7 },
  { left: "84%", size: 29, dur: 10, delay: -2 },
]

type Props = { onZpet: () => void; onVybrat?: (p: Postava) => void }

export default function Postavy({ onZpet, onVybrat }: Props): React.ReactElement {
  const [vybrana, setVybrana] = useState<Postava>(postavy[0]!)

  return (
    <div className="postavy-root" style={{ height: "calc(100vh - 40px)", width: "calc(100vw - 40px)", overflow: "hidden", backgroundColor: "transparent", position: "relative" }}>
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
          backgroundImage: `url(${bgMenu})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.1
        }}
      />

      <div aria-hidden style={{ position: "absolute", inset: 0, zIndex: 1, pointerEvents: "none" }}>
        {COOKIES_LARGE.map((c, i) => (
          <img key={`cl${i}`} src={cookieBg} alt="" style={{
            position: "absolute", left: c.left, top: "-50px", width: c.size, height: c.size,
            opacity: 0.35, objectFit: "contain",
            animation: `cookieFall ${c.dur}s linear ${c.delay}s infinite`
          }} />
        ))}
        {COOKIES_SMALL.map((c, i) => (
          <img key={`cs${i}`} src={cookieBg} alt="" style={{
            position: "absolute", left: c.left, top: "-30px", width: c.size, height: c.size,
            opacity: 0.22, objectFit: "contain",
            animation: `cookieFallSmall ${c.dur}s linear ${c.delay}s infinite`
          }} />
        ))}
      </div>

      <div style={{ position: "relative", zIndex: 10 }}>
        <div className="postavy-top" style={{ position: "relative", zIndex: 15 }}>
          <div className="postava-preview" style={{ position: "relative", zIndex: 15 }}>
            <img src={vybrana.nahled} alt={vybrana.jmeno} className="postava-foto" draggable="false" onDragStart={(e) => e.preventDefault()} />
          </div>
          <div className="postava-info">
            <h2>{vybrana.jmeno}</h2>
            <p className="slogan">{vybrana.slogan}</p>
            <ul className="vlastnosti">
              <li>Limit kofeinu: {vybrana.kofein_limit} mg</li>
              <li>Cookies za klik: {vybrana.cookies_za_klik_start}</li>
              <li>Autoclicker: {vybrana.ma_autoclicker ? `${vybrana.autoclicker_cookies_za_sec} cookies/sec` : "Ne"}</li>
            </ul>
            <div style={{ marginTop: 16, display: "flex", gap: "16px", flexWrap: "wrap" }}>
              <button className="pixel-button" onClick={() => onZpet()}>← Zpět</button>
              {onVybrat && <button className="pixel-button" onClick={() => onVybrat(vybrana)}>Vybrat a začít</button>}
            </div>
          </div>
        </div>

        <div className="postavy-grid">
          {postavy.map((p) => (
            <div key={p.id} className={`postava-karta ${vybrana.id === p.id ? "aktivni" : ""}`} onClick={() => setVybrana(p)}>
              <img src={p.nahled} alt={p.jmeno} className="postava-foto-mala" draggable="false" onDragStart={(e) => e.preventDefault()} />
              <h3>{p.jmeno}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}